<app-courses title="To Review" status="in_review"></app-courses>